import React, { useState } from 'react';
import { Button, TextField } from '@material-ui/core';
import { Redirect, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import {
  // playerCreate,
  playerEditName,
  gameAddPlayer,
  gameAddRound,
  roundCreate,
  setCurrentRound
} from '../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles(function(theme) {
  return {
    paper: {
      minHeight: '80px',
      margin: '12px 0'
    },
    continueButton: {
			margin: '20px 0px',
    }
  };
});

export default () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  let history = useHistory();
  const gameList = useSelector(state => state.games);

  if (gameList.currentGame === '') {
    return <Redirect to="/" />;
  }

  const [nameList, setName] = useState();

  const startGame = () => {
    for (const key in nameList) {
      if (nameList.hasOwnProperty(key)) {
        const element = nameList[key];
        if (element.name !== '') {
          dispatch(gameAddPlayer(gameList.currentGame, element.id));
        }
      }
    }

    const roundId = 'round' + Date.now();
    const roundIndex = 0; //first round always from this page

    //create round
    dispatch(roundCreate(roundId, roundIndex));
    //set surrent round
    dispatch(setCurrentRound(roundId));
    //add round to game (1st round)
    dispatch(gameAddRound(gameList.currentGame, roundId));
    history.push('round-details');
  };

  const editPlayer = playerId => event => {
    dispatch(playerEditName(playerId, event.target.value));
    const data = nameList[playerId];
    setName({ ...nameList, [playerId]: { ...data, name: event.target.value } });
  };

  const createPlayerInput = () => {
    const newId = 'player' + Date.now();
    setName({ ...nameList, [newId]: { id: newId, name: '' } });
  };

  const createInputElements = () => {
    const elementList = [];

    for (const key in nameList) {
      if (nameList.hasOwnProperty(key)) {
        const data = nameList[key];

        elementList.push(
          <span key={data.id} className="center">
            <TextField
              id="standard-name"
              label="Name"
              value={data.name}
              onChange={editPlayer(data.id)}
              margin="normal"
            />
            <br />
          </span>
        );
      }
    }

    return elementList;
  };

  if (createInputElements().length < 3) {
    createPlayerInput();
    window.setTimeout(() => {
      createPlayerInput();
    }, 100);
  }

  return (
    <React.Fragment>
      <form>
        {createInputElements()}
        <div
          className="center"
          style={{
            flexDirection: 'column',
            padding: '20px 120px'
          }}
        >
          {createInputElements().length < 6 ? (
            <Button
              variant="outlined"
              onClick={createPlayerInput}
              style={{
								margin: '20px 0px'
              }}
            >
              + add player
            </Button> //todo a "new player input"
          ) : null}
          <Button
            variant="contained"
            type="submit"
            color="secondary"
            disabled={createInputElements().length < 3}
						onClick={startGame}
						className={classes.continueButton}
          >
            START GAME
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};
